import React from "react";
import ProductCard from "../../Cards/ProductCard";
import ProductDetail from "../ProductDetail/ProductDetail";
import Slider from "../../Swiper/CardsSwiper/Slider.jsx";
import photo1 from "../../../assets/card1.png";
import { Box, makeStyles } from "@material-ui/core";
import imgtest from "./SEA_8638.jpg";
const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  cardsContainer: {
    margin: spacing(2),
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: spacing(3),
  },
}));

const Decorativas = () => {
  const classes = useStyles();

  const productCard = {
    img: photo1,
    title: "Purple Grape",
    sizes: "!0x10x10",
    colors: "lrojo, azul, negro",
    smell: "Floral",
    code: "090291309",
  };

  const firstCards = (
    <Box component="div" className={classes.cardsContainer}>
      <ProductCard info={productCard} />
      <ProductCard info={productCard} />
      <ProductCard info={productCard} />
    </Box>
  );

  return (
    <Box component="div" className={classes.marginBack}>
      <ProductDetail />
      <Slider card1={firstCards} card2={firstCards} />
      {/* <Box component="div" className={classes.background} /> */}
    </Box>
  );
};

export default Decorativas;
